if (window.GrindGuide) {
  window.GrindGuide.mount();
} else {
  window.GrindGuide = {
    moveSidebars: function() {
      document.querySelectorAll('sidebar-drawer.grind-guide-sidebar').forEach(function(sidebar) {
        if (sidebar.parentNode !== document.body) {
          document.body.appendChild(sidebar);
        }
      });
    },
    onTriggerClick: function(event) {
      const trigger = event.target.closest('[data-js-grind-guide-trigger]');
      if (!trigger) return;
      event.preventDefault();
      const sidebar = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!sidebar || typeof sidebar.show !== 'function') return;
      trigger.setAttribute('aria-expanded', 'true');
      sidebar.show();
    },
    mount: function() {
      if (document.body.hasAttribute('data-grind-guide-mounted')) {
        window.GrindGuide.moveSidebars();
        return;
      }
      document.body.setAttribute('data-grind-guide-mounted', '');
      document.addEventListener('click', window.GrindGuide.onTriggerClick);
      window.GrindGuide.moveSidebars();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.GrindGuide.mount);
  } else {
    window.GrindGuide.mount();
  }

  document.addEventListener('shopify:section:load', window.GrindGuide.mount);
}
